import Swiper from 'swiper'
import { Navigation, HashNavigation, Keyboard } from 'swiper/modules'

const gallerySliders = document.querySelectorAll('.gallery-slider')

function initGallerySliders() {
    if (!gallerySliders.length) return
    gallerySliders.forEach((gallerySlider) => {
        const swiper = new Swiper(gallerySlider, {
            modules: [Navigation, HashNavigation, Keyboard],
            loop: true,
            keyboard: {
                enabled: true,
            },
            hashNavigation: {
                watchState: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        })
    })
}

document.addEventListener('DOMContentLoaded', initGallerySliders)

function toggleGallery(openGalleryButton, event) {
    const gallery = openGalleryButton.closest('.gallery')
    const gallerySliderModal = gallery.querySelector('.gallery-slider-modal')

    if (event === 'open') {
        gallerySliderModal.classList.add('active')
    } else {
        gallerySliderModal.classList.remove('active')
    }
}

document.addEventListener('click', (e) => {
    if (e.target.closest('.open-gallery')) {
        const openGalleryButton = e.target.closest('.open-gallery')
        toggleGallery(openGalleryButton, 'open')
    }

    if (e.target.closest('.close-gallery')) {
        const closeGalleryButton = e.target.closest('.close-gallery')
        toggleGallery(closeGalleryButton, 'close')
    }
})

document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        const gallerySliderModals = document.querySelectorAll('.gallery-slider-modal')
        gallerySliderModals.forEach((gallerySliderModal) => {
            gallerySliderModal.classList.remove('active')
        })
    }
})
